export const hasNextPage = (
    perPage: number,
    offset: number,
    totalCount: number
): boolean => {
    return offset + perPage < totalCount;
};
